<template>
  <div class="main">
    <div class="main_right">
      <div class="page_info">
        <Breadcrumb class="breadcrumb">
          <BreadcrumbItem>添加商户</BreadcrumbItem>
        </Breadcrumb>
        <div class="dev_data">
          <div><span class="line_name"><b>*</b>商户名</span><Input v-model="userForm.merchantName" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name"><b>*</b>商户代码</span><Input v-model="userForm.merchantCode" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name"><b>*</b>联系人</span><Input v-model="userForm.contactName" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name"><b>*</b>联系电话</span><Input v-model="userForm.contactPhone" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name">联系邮箱</span><Input v-model="userForm.contactMail" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name"><b>*</b>地址</span><Input v-model="userForm.addr" style="width: 300px" :maxlength=32 /></div>
          <div><span class="line_name">备注</span><Input v-model="userForm.memo" style="width: 300px" :maxlength=32 /></div>
          <div class="btn">
            <Button type="primary" style="width: 120px;" @click="submit">确定</Button>
            <Button style="width: 120px;" @click="goBackPage">取消</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {httpUrl} from '../../api/index'
import TopOpe from '../top-ope/top-ope'
import {errorHandler} from '../../util/errorHandler'
import {nSuccess, nError} from '../../util/notice'
import {pattern} from '../../util/regular'

export default {
  components: {TopOpe},
  name: 'add-business',
  data () {
    return {
      userForm: {
        merchantName: '',
        merchantCode: '',
        contactName: '',
        contactPhone: '',
        contactMail: '',
        addr: '',
        memo: ''
      }
    }
  },
  methods: {
    goBackPage () {
      this.$router.push({
        path: '/business_management'
      })
    },
    submit () {
      let phoneTest = pattern.phone.test(this.userForm.contactPhone)
      let emailTest = pattern.email.test(this.userForm.contactMail)
      if (!this.userForm.merchantName) {
        nError('商户名不能为空')
        return false
      }
      if (!this.userForm.merchantCode) {
        nError('商户代码不能为空')
        return false
      }
      if (!this.userForm.contactName) {
        nError('联系人不能为空')
        return false
      }
      if (!this.userForm.contactPhone) {
        nError('联系电话不能为空')
        return false
      }
      if (!phoneTest) {
        nError('请输入正确的手机号')
        return false
      }
      if (this.userForm.contactMail && !emailTest) {
        nError('请输入正确的邮箱')
        return false
      }
      if (!this.userForm.addr) {
        nError('地址不能为空')
        return false
      }
      this.$axios.post(`${httpUrl.url}/manage/merchant/add`, this.userForm)
        .then(res => {
          if (res.data.retCode === 1) {
            nSuccess('添加成功')
            this.goBackPage()
          }
        })
        .catch(errorHandler('添加失败'))
    }
  }
}
</script>

<style scoped>
  .main {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
  }

  .main_right {
    width: 100%;
    height: 100%;
  }

  .breadcrumb {
    margin-bottom: 10px;
    border-left: 3px solid #00A0E6;
    padding-left: 5px;
  }
  .page_info {
    margin: 15px;
    background-color: #fff;
  }

  .dev_data {
    margin-top: 80px;
  }

  .dev_data div {
    margin: 10px;
    text-align: center;
  }

  b {
    color: red;
  }

  .line_name {
    display: inline-block;
    width: 55px;
    text-align: right;
  }

  .btn button {
    margin: 30px 20px 0;
  }
</style>



// WEBPACK FOOTER //
// src/views/warehouse-management/add-business.vue